import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import ModalContainer from "./components/@Portal/ModalContainer";
import router from "./routers";
import { useThemeStore } from "./stores/themeStore";
import { useAxiosInterceptor } from "./utils/axiosInstance";
import "@assets/styles/base/_reset.scss";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
		},
	},
});

function App() {
	const { mode } = useThemeStore(["mode"]);
	useAxiosInterceptor();
	useEffect(() => {
		document.documentElement.setAttribute("data-theme", mode);
	}, [mode]);

	return (
		<QueryClientProvider client={queryClient}>
			<div
				style={{
					height: "100dvh",
					backgroundColor: "var(--background)",
				}}
			>
				<RouterProvider router={router} />
				<ModalContainer />
			</div>
		</QueryClientProvider>
	);
}

export default App;
